import template from './failedAction.html';
import controller from './failedAction.controller.js';
import './failedAction.scss';

let failedActionComponent = {
  restrict: 'E',
  bindings: {
    title: '@',
    description: '@',
    closeModal: '@',
    modalId: '@',
    buttonText: '@',
    onDismiss: '&',
    modSize: '@',
    avoidCallbackOnClose: '<',
    isMobileApp: '<',
    onClick: '&',
  },
  template,
  controller,
};

export default failedActionComponent;



// WEBPACK FOOTER //
// ./client/app/components/failedAction/failedAction.component.js